<script setup lang="ts">
// A live countdown to `target` (an ISO instant or ms), on the shared one-second ticker.
// `now` is the clock to count against: @itc/ui doesn't depend on @itc/sdk, so pages
// pass the server's (useConnectionStore().serverNow). `format` is long (`1d 02:03:04`)
// or short (`in 3h`); once the target passes it shows `endedLabel`, or `00:00:00`.
import { computed } from 'vue';
import { formatCountdown, targetMs, type CountdownFormat } from '../countdown.ts';
import { useTicker } from '../use-ticker.ts';

const props = withDefaults(defineProps<{ target: string | number; now?: () => number; format?: CountdownFormat; endedLabel?: string | undefined }>(), {
  now: () => Date.now(),
  format: 'long',
});
const tick = useTicker();

const remaining = computed(() => {
  void tick.value;
  return targetMs(props.target) - props.now();
});
const ended = computed(() => remaining.value <= 0);
const text = computed(() => (ended.value && props.endedLabel !== undefined ? props.endedLabel : formatCountdown(remaining.value, props.format)));
const datetime = computed(() => new Date(targetMs(props.target)).toISOString());
</script>

<template>
  <time class="itc-countdown num" :class="{ 'itc-countdown--ended': ended }" role="timer" :datetime="datetime">{{ text }}</time>
</template>
